"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XHRAuthoriserPluginWithTrustedDevice = void 0;
const xhrAuthoriserPlugin_1 = require("./xhrAuthoriserPlugin");
class XHRAuthoriserPluginWithTrustedDevice extends xhrAuthoriserPlugin_1.XHRAuthoriserPlugin {
    constructor(authoriser) {
        super(authoriser);
        this.authoriser = authoriser;
    }
    async handleResponse(response) {
        const { data: { data, responseHeaders: { ['x-security']: securityHeader }, }, reference: { url }, } = response;
        const challengeResponseData = data;
        return new Promise(resolve => {
            switch (securityHeader) {
                case xhrAuthoriserPlugin_1.SecurityHeader.NO_TRUSTED_DEVICE:
                    if (!this.authoriser.state.isStarted) {
                        this.authoriser.initializeAuthoriser(challengeResponseData, response.calls.originCall, url);
                    }
                    this.authoriser.noTrustedDevice();
                    return;
                default:
                    resolve(super.handleResponse(response));
            }
        });
    }
}
exports.XHRAuthoriserPluginWithTrustedDevice = XHRAuthoriserPluginWithTrustedDevice;
//# sourceMappingURL=xhrAuthoriserTrustedDevicePlugin.js.map